import * as sharedConstants from '../Constants/SharedConstants';

const readWebUBrandFromMeta = () => {
    if (typeof document === 'undefined') {
        return '';
    }
    const meta = document.querySelector('meta[name="webu-brand"]');
    return meta?.getAttribute('content')?.trim().toLowerCase() || '';
};

const readWebUBrandFromHostname = () => {
    if (typeof window === 'undefined') {
        return '';
    }
    const hostname = window.location.hostname.toLowerCase();
    if (hostname.includes('chevrolet')) {
        return sharedConstants.b_chevrolet;
    }
    if (hostname.includes('buick')) {
        return sharedConstants.b_buick;
    }
    if (hostname.includes('gmc')) {
        return sharedConstants.b_gmc;
    }
    if (hostname.includes('cadillac')) {
        return sharedConstants.b_cadillac;
    }
    return '';
};

/** Theme code for setCSSThemeMake (e.g. chevrolet, buick). Meta tag first, then hostname. */
export const getWebUBrandThemeCode = () => {
    const fromMeta = readWebUBrandFromMeta();
    if (fromMeta && fromMeta !== 'crossbrand') {
        return fromMeta;
    }
    return readWebUBrandFromHostname();
};

/** Display make for CSSRenderer (e.g. Chevrolet, Buick). */
export const themeCodeToThemeMake = (themeCode) => {
    switch (themeCode?.toLowerCase()) {
        case sharedConstants.BU.toLowerCase():
        case sharedConstants.b_buick:
            return sharedConstants.Buick;
        case sharedConstants.CA.toLowerCase():
        case sharedConstants.b_cadillac:
            return sharedConstants.Cadillac;
        case sharedConstants.CH.toLowerCase():
        case sharedConstants.b_chevrolet:
            return sharedConstants.Chevrolet;
        case sharedConstants.GM.toLowerCase():
        case sharedConstants.b_gmc:
            return sharedConstants.GMC;
        default:
            return '';
    }
};

export const getWebUBrandThemeMake = () => themeCodeToThemeMake(getWebUBrandThemeCode());

/** Origin code for ossDetermineFlow BrandFlow (e.g. CHEVY, BUICK). */
export const themeCodeToOrigin = (themeCode) => {
    switch (themeCode?.toLowerCase()) {
        case sharedConstants.b_buick:
        case 'bu':
            return 'BUICK';
        case sharedConstants.b_cadillac:
        case 'ca':
        case 'cad':
            return 'CAD';
        case sharedConstants.b_chevrolet:
        case 'ch':
        case 'chevy':
            return 'CHEVY';
        case sharedConstants.b_gmc:
        case 'gm':
            return 'GMC';
        default:
            return '';
    }
};

export const getWebUOrigin = () => themeCodeToOrigin(getWebUBrandThemeCode());
